import clsx from "clsx";
import { EntryButton } from "@/components";
import "./LoginBanner.scss";

export type LoginBannerEntry = {
  href: string;
  label: React.ReactNode;
  ariaLabel?: string;
  showIcon?: boolean;
  icon?: React.ReactNode;
  asLink?: "a" | React.ComponentType<any>;
};

export type LoginBannerProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
  entries: LoginBannerEntry[];
  rightDescription?: React.ReactNode;
  rightContent: React.ReactNode;
  className?: string;
  entryButtonAsLink?: "a" | React.ComponentType<any>;
};

export const LoginBanner = ({
  title,
  description,
  entries,
  rightDescription,
  rightContent,
  className,
  entryButtonAsLink = "a",
}: LoginBannerProps) => {
  return (
    <div className={clsx("ui-login-banner bg-white shadow br-x4", className)}>
      <div className="ui-login-banner-left">
        <div className="ui-login-banner-text">
          <h2 className="fw-semibold fs-4 text-slate-20">{title}</h2>
          {description && (
            <div className="fs-6 text-slate-28">{description}</div>
          )}
        </div>
        <div className="ui-login-banner-buttons">
          {entries.map((entry, index) => (
            <EntryButton
              key={`${entry.href}-${index}`}
              href={entry.href}
              ariaLabel={entry.ariaLabel ?? "Accedi"}
              showIcon={entry.showIcon}
              icon={entry.icon}
              asLink={entry.asLink ?? entryButtonAsLink}
            >
              {entry.label}
            </EntryButton>
          ))}
        </div>
      </div>
      <div className="ui-login-banner-divider" aria-hidden="true" />
      <div className="ui-login-banner-right">
        {rightDescription && (
          <div className="ui-login-banner-right-description">
            {rightDescription}
          </div>
        )}
        {rightContent}
      </div>
    </div>
  );
};
